export const SET_USER_NAME = 'SET_USER_NAME'
export const SET_PERMISSIONS = 'SET_PERMISSIONS'
export const SET_USER_EMAIL = 'SET_USER_EMAIL'
export const SET_USER_DEPARTMENT = 'SET_USER_DEPARTMENT'
